export default __webpack_public_path__ + "static/IBMPlexSans-ThinItalic-5ae8e811e5922c34dcc3f0413bc2cb9e.woff2";